<template>
  <div class="callout">
    <div class="wrap">
      <div class="content">
        <p>We think far beyond feature requests and focus on experiences in their entirety, driving major project initiatives and pushing the envelope of efficiency, learnability and usability.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "callout"
};
</script>

<style lang="scss" scoped>
.callout {
  background: #111215;
  display: flex;
  height: 744px;
  justify-content: center;
  align-items: center;
  margin-top: -64px;
  @media(max-width: 700px) {
    height: inherit;
    padding: 32px 16px;
    margin-top: -32px;
  }
  .content {
    max-width: 926px;
    padding-left: 101px;
    position: relative;
    @media(max-width: 700px) {
      padding-left: 54px;
    }
    &:before {
      content: '';
	    height: 66px;
      width: 38px;
      background-image: url('../../public/img/seafire_callout_logo.svg');
      background-repeat: no-repeat;
      display: block;
      position: absolute;
      left: 0px;
      top: -12px;
    }
  }
  p {
    color: #ffffff;
    font-family: Archia;
    font-size: 32px;
    font-weight: 300;
    letter-spacing: 0.5px;
    line-height: 56px;
        @media(max-width: 700px) {
          font-size: 22px;
          line-height: 42px;
    }
  }
}
</style>